import type { LucideIcon } from 'lucide-react';

export type CargoMetricCardProps = {
  label: string;
  value: string;
  unit?: string;
  hint?: string;
  chip?: string;
  icon: LucideIcon;
  tone?: 'gold' | 'blue' | 'green' | 'amber' | 'red' | 'neutral';
  loading?: boolean;
  warn?: boolean;
  progress?: number;
};

const toneStyles: Record<
  NonNullable<CargoMetricCardProps['tone']>,
  { color: string; bg: string }
> = {
  gold: { color: 'var(--onyx-gold)', bg: 'var(--onyx-gold-dim)' },
  blue: { color: 'var(--onyx-blue)', bg: 'var(--onyx-blue-dim)' },
  green: { color: 'var(--onyx-green)', bg: 'var(--onyx-green-dim)' },
  amber: { color: 'var(--onyx-amber)', bg: 'rgba(245, 158, 11, 0.12)' },
  red: { color: 'var(--onyx-red)', bg: 'var(--onyx-red-dim)' },
  neutral: { color: 'var(--onyx-text)', bg: 'rgba(255,255,255,0.06)' },
};

export function CargoMetricCard({
  label,
  value,
  unit,
  hint,
  chip,
  icon: Icon,
  tone = 'neutral',
  loading = false,
  warn = false,
  progress,
}: CargoMetricCardProps) {
  const style = toneStyles[tone];

  return (
    <div
      className={`admin-stat cargo-stat-card cargo-metric-card${warn ? ' cargo-metric-warn' : ''}`}
    >
      <div className="cargo-metric-top">
        <div className="admin-stat-icon" style={{ background: style.bg }}>
          <Icon size={18} color={style.color} aria-hidden />
        </div>
        {chip ? <span className="cargo-metric-chip">{chip}</span> : null}
      </div>
      <div className="stat-label">{label}</div>
      <div className="cargo-metric-value-row">
        <span className="cargo-stat-value" style={{ color: style.color }}>
          {loading ? '…' : value}
        </span>
        {unit && !loading ? <span className="cargo-metric-unit">{unit}</span> : null}
      </div>
      {hint ? <div className="cargo-stat-hint">{hint}</div> : null}
      {progress != null && progress >= 0 ? (
        <div className="cargo-metric-progress" aria-hidden>
          <div className="cargo-metric-progress-fill" style={{ width: `${Math.min(100, progress)}%` }} />
        </div>
      ) : null}
    </div>
  );
}
